import 'tablesorter';
import 'tablesorter/dist/js/extras/jquery.tablesorter.pager.min.js';
import 'tablesorter/dist/css/theme.ice.min.css';

import Header from '../../../../components/Header';
import Footer from '../../../../components/Footer/Footer';

import { MMANavbar } from '../../../../components/Tools/Navbar/Navbar';
import { Breadcrumb, Tab, Tabs, Table } from 'react-bootstrap';
import { FaHome } from 'react-icons/fa';
import OverallLayout from '../assets/overall-layout.png';
import MainLayout from '../assets/main-layout.png';
import TailgateLayout from '../assets/tailgate-layout.png';

import 'bootstrap/dist/css/bootstrap.min.css';

const EquipmentOverview = () => {
	return (
		<>
			<Header plant="montgomery" />
			<main>
				<wrapper class="section-wrapper">
					<MMANavbar />
					<container class="section-container">
						<Breadcrumb>
							<Breadcrumb.Item href="/smart-inspect/montgomery/overview">
								<FaHome size={20} />
							</Breadcrumb.Item>
							<Breadcrumb.Item active>Equipment</Breadcrumb.Item>
							<Breadcrumb.Item active>Equipment Overview</Breadcrumb.Item>
						</Breadcrumb>
						<content class="section-content">
							<Tabs defaultActiveKey="Overall Layout" className="mb-3">
								<Tab eventKey="Overall Layout" title="Overall Layout">
									<div class="tab-section" style={{ justifyContent: 'space-between' }}>
										<h2>OVERALL LAYOUT</h2>

										<img src={OverallLayout} style={{ width: '75vw' }} />
									</div>
								</Tab>

								<Tab eventKey="Main Layout" title="Main Layout">
									<div class="tab-section" style={{ display: 'flex', justifyContent: 'space-between' }}>
										<div class="left-side">
											<h2>MAIN LAYOUT</h2>
											<ol>
												<li>
													Power Distribution Panel (<b>PDP</b>)
												</li>
												<li>Transformer Stand</li>
												<li>
													System Control Console (<b>SCC</b>)
												</li>
												<li>
													Server Panel (<b>SP</b>)
												</li>
												<li>
													Trigger Panel 1 (<b>TP1</b>)
												</li>
												<li>
													Trigger Panel 2 (<b>TP2</b>)
												</li>
												<li>
													Inspection Monitor (<b>MON</b>)
												</li>
												<li>Main Body Universal Assembly</li>
												<li>Main Body Cover Assembly</li>
												<li>Encoder Big Wheel Tracker</li>
												<li>Roller Bed Skid Present Assembly</li>
												<li>Door Open Scanner Assembly</li>
											</ol>
										</div>
										<img src={MainLayout} style={{ width: '50vw', marginRight: '5px' }} />
									</div>
								</Tab>

								<Tab eventKey="Tailgate Layout" title="Tailgate Layout">
									<div class="tab-section" style={{ display: 'flex', justifyContent: 'space-between' }}>
										<div class="left-side">
											<h2>TAILGATE LAYOUT</h2>
											<ol>
												<li>Trigger Panel 3</li>
												<li>Tailgate Universal Assembly</li>
												<li>Tailgate Cover Assembly</li>
												<li>Cross Over Encoder</li>
												<li>Cross Over Conveyor Skid Present Assembly</li>
											</ol>
										</div>
										<img src={TailgateLayout} style={{ width: '35vw', marginRight: '5px' }} />
									</div>
								</Tab>

								<Tab eventKey="Sequence of Operations" title="Sequence of Operations">
									<h2>SEQUENCE OF OPERATIONS</h2>
									<Table striped bordered hover>
										<thead>
											<tr>
												<th>Seq. No.</th>
												<th>Sequence Description</th>
											</tr>
										</thead>
										<tbody>
											<tr>
												<td>1</td>
												<td>Use the SMARTInspect system to scan vehicle.</td>
											</tr>
											<tr>
												<td>2</td>
												<td>Inspect the vehicle for defects to be repaired.</td>
											</tr>
											<tr>
												<td>3</td>
												<td>
													From the SMARTInspect <b>HMI</b>, open the scan history for the vehicle and select the defect to be repaired, and data is sent to the monitors at the Quality Repair Deck.
												</td>
											</tr>
											<tr>
												<td>4</td>
												<td>Operators repair the defects.</td>
											</tr>
										</tbody>
									</Table>
								</Tab>
							</Tabs>
						</content>
					</container>
				</wrapper>
			</main>
			<Footer />
		</>
	);
};

export default EquipmentOverview;
